

<template>
    <div> 
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>  
        <div class="d-flex flex-column PaymentForm" v-for="item in payData">
            <div class="d-flex justify-content-between PaymentTitle">
                <div class="">交易內容：</div>
                <div>待繳款金額：{{item.payMoney}}</div>
            </div>
            <div class="PaymentSubForm"> 
                <div class="d-flex my-2 align-items-center" >
                    <span class=" mx-2">金流公司：</span>
                    <img class="" src="../../assets/images/payuni.png" width="120">
                </div>
                <div class="d-flex align-items-center my-2">
                    <span class=" mx-2">繳款類別：</span>
                    <span>{{item.payType}}</span>
                </div>
                <div class="d-flex align-items-center my-2">
                    <span class="mx-2">繳款單號：</span>
                    <span>{{item.payOrderId}}</span>
                </div>
                <div class="d-flex align-items-top my-2">
                    <span class="mx-2">課程名稱：</span>
                    <div class="d-flex flex-column">
                        <span v-for="course in item.courseName">{{course}}</span>
                    </div>
                </div>
                <div class="d-flex align-items-center my-2">
                    <span class="mx-2">付款到期日：</span>
                    <span>{{item.payEndDate}}</span>
                </div>
            </div>
            <div class="ml-auto mt-2 mr-3 PayBtn" @click="GetPAYUNiReturnData(item)">前往付款</div>

        </div>
    </div>
</template>
<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'PayHome',
    components:{Nav},
    data () {
        return {
            showLoading:'',
            VerificationCode:'',
            payData:[{
            }],
            PayUniData:'',
        }
    },
    mounted(){
        

    },
    methods:{
        CheckPayAndGetData(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Pay/CheckPayAndGetData`;
            const inputdata = 
            {
                "VerificationCode":this.VerificationCode,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){
                        this.payData = response.data.payData;

                    }else{
                        //跳轉付款失敗畫面
                        this.$router.push({
                            name: 'PayFail',
                            params: {
                                message:response.data.message
                            }

                        });
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        GetPAYUNiReturnData(item){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Pay/GetPAYUNiReturnData`;
            const inputdata = 
            {
                "PayId":item.payId,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){
                        this.PayUniData = response.data.payData;
                        sessionStorage.setItem('paySendTime',moment(new Date()).format('yyyy-MM-DD HH:mm:ss'));
                        sessionStorage.setItem('OrderData',JSON.stringify(item));
                        
                        this.$router.push({
                            name: 'PayPage',
                            params: {
                                PayData:this.PayUniData,
                            }
                        });
                    }else{
                        alert(response.data.message)
                        // //跳轉付款失敗畫面
                        this.$router.push({
                            name: 'PayFail',
                        });
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
    },
    created(){
        //先get網址的內容
        if(this.$route.query.lc_key != undefined){
            this.VerificationCode = this.$route.query.lc_key
            this.CheckPayAndGetData();
        }else{
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/PayHome.vue